// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom_process .custom_process_item[data-v-4d9c7530]{display:-webkit-box;display:-ms-flexbox;display:flex}.custom_process .custom_process_item .custom_process_item_left[data-v-4d9c7530]{width:20px}.custom_process .custom_process_item .custom_process_iten.content[data-v-4d9c7530]{-webkit-box-flex:1;-ms-flex:1;flex:1}", ""]);
// Exports
module.exports = exports;
